import { useQuery } from "@apollo/client";

import { GqlClientGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { ClientListScreen_GetAllDocument } from "../queries.generated";

export default function useClientListScreen_GetAll(params: GqlClientGetAllParams) {
    const { data, loading, error } = useQuery(ClientListScreen_GetAllDocument, {
        variables: { params: params },
    });

    const queryInfo = data?.clientGetAll?.queryInfo;
    const [_, total] = useCacheFilterOptions(null, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        totalRows: total,
        sortableColumns: queryInfo?.sortableColumns,
        data: data?.clientGetAll?.data,
    };
}
